import { render, staticRenderFns } from "./RetirementAdequacyView.vue?vue&type=template&id=552f2878&scoped=true"
import script from "./RetirementAdequacyView.vue?vue&type=script&lang=ts"
export * from "./RetirementAdequacyView.vue?vue&type=script&lang=ts"
import style0 from "./RetirementAdequacyView.vue?vue&type=style&index=0&id=552f2878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f2878",
  null
  
)

export default component.exports